var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center app-content-back w-screen mt-0 align-top min-h-screen pt-4"},[_c('div',{staticClass:"container mx-auto"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }